import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { SERVICES, HttpMethods } from '../../services/api';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

interface IUpdateQuestionPackagesDTO {
  accountId: string;
  questionsPackages: string[];
}

interface IDataDTO {
  questionsPackages: string[];
}

export const updateQuestionPackages: AsyncThunk<void, IUpdateQuestionPackagesDTO, ThunkAPI> = createAsyncThunk(
  'updateQuestionPackages',
  async (dto: IUpdateQuestionPackagesDTO, thunk) => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      thunk.dispatch({
        type: 'DO_NOTHING'
      });
      return;
    }
    try {
      const { accountId, questionsPackages } = dto;
      const data = { questionsPackages };
      const response = await basicApiAsyncThunkCreator<void, IDataDTO>({
        endpoint: `accounts/${accountId}/update-questions-packages`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(data, thunk);
      thunk.dispatch(showSuccessMessage('The question packages has been saved!'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage('An error occurred'));
      return thunk.rejectWithValue(err);
    }
  }
);
